/* eslint-disable no-empty */
import { clone, isNil, omit, pick } from 'lodash';
import {
  MAX_TIME_FOR_BOT_DICE,
  MIN_TIME_FOR_BOT_DICE,
  TIME_FOR_GAME_LOADING,
  TIME_FOR_THROW_DICE,
  asyncSetTimeOut,
  getDiceNumber,
  getNextPlayer,
  getRandomInt,
  getStartingPosition,
  getTimeStamp,
  getUniqueId,
  ludoDefaultSafeHousePosition,
  sendEventToGame
} from './utils';

export interface PlayerCacheInfo {
  currentPlayerId: string;
  contestId: string;
  currentPlayerUserId: string;
  currentPlayerSeatIndex: number;
  currentDiceNumber: number;
  currentTurnId: string;
  winners: string[];
  turnEndTimestamp: number;
  players: {
    [key: string]: {
      tokens: number[];
      playerId: string;
      seatIndex: number;
      username: string;
      userId: string;
      sessionId: string;
      avatarId: number;
      rank: number;
      continueSixCounter: number;
      status: number;
      winning: number;
      isBotUser: boolean;
      currencyType: number;
      userProfileLink: string;
      missingTurnCounter: number;
    };
  };
  round: number;
  firstMover: string;
}

export const contest = [];

export const myUserId = getUniqueId();

let gameCompleted = false;

let diceTurnTimeout: any = null;

export const gameInfo: any = {
  roomId: getUniqueId(),
  currentPlayerId: '6570067b75c8941dd1cd5902',
  currentPlayerUserId: '653a0405d494ca2cf5349c28',
  currentDiceNumber: 0,
  players: {
    '6570067b75c8941dd1cd5902': {
      tokens: [0, 0, 0, 0],
      seatIndex: 1,
      playerId: '6570067b75c8941dd1cd5902',
      userId: myUserId,
      sessionId: '653a0405d494ca2cf5349c29',
      avatarId: 0,
      username: 'Sergio',
      winning: 0,
      isBotUser: false,
      currencyType: 1,
      missingTurnCounter: 0,
      continueSixCounter: 0,
      rank: 0,
      status: 1,
      userProfileLink:
        'https://predev-vinfotech-org.s3.amazonaws.com/upload/profile/thumb/avatar7.png'
    },
    '6570067875c8941dd1cd5900': {
      tokens: [0, 0, 0, 0],
      seatIndex: 3,
      playerId: '6570067875c8941dd1cd5900',
      userId: '652d11e600c48e2bd72e1b39',
      sessionId: '653a03ccd494ca2cf5349c26',
      avatarId: 0,
      username: 'laxman',
      winning: 0,
      isBotUser: true,
      currencyType: 1,
      missingTurnCounter: 0,
      continueSixCounter: 0,
      rank: 0,
      status: 1,
      userProfileLink:
        'https://predev-vinfotech-org.s3.amazonaws.com/upload/profile/thumb/avatar3.png'
    }
  },
  winners: [],
  round: 1,
  turnEndTimestamp: 1701840537762,
  currentTurnId: '6570068375c8941dd1cd5905',
  contestId: '6570053075c8941dd1cd58f8',
  firstMover: '6570067b75c8941dd1cd5902',
  currentPlayerSeatIndex: 1
};

export const teams = [
  {
    userId: myUserId,
    avatarId: 1,
    username: 'You',
    sessionId: '653a0405d494ca2cf5349c29',
    teamId: '6570067b75c8941dd1cd5902',
    seatIndex: 1,
    playerId: '6570067b75c8941dd1cd5902'
  },
  {
    userId: '652d11e600c48e2bd72e1b39',
    avatarId: 1,
    username: 'laxman',
    sessionId: '653a03ccd494ca2cf5349c26',
    playerId: '6570067875c8941dd1cd5900',
    teamId: '6570067875c8941dd1cd5900',
    isBotUser: true,
    seatIndex: 3
  }
];

export class GameService {
  createGameAndTeam(gamePlayId: string, contestId: string, teams: any[]) {
    const players = [] as any[];
    for (let index = 0; index < teams.length; index++)
      players.push({
        ...pick(teams[index], ['userId', 'avatarId', 'username', 'sessionId']),
        _id: teams[index].teamId,
        gamePlayId: gamePlayId,
        rank: 1,
        status: 1,
        winning: 0,
        startTime: new Date(),
        sessionId: teams[index].sessionId,
        tokens: [0, 0, 0, 0],
        seatIndex: index + 1,
        avatarId: teams[index].avatarId,
        username: teams[index].username,
        missingTurnCounter: 0,
        continueSixCounter: 0,
        isBotUser: teams[index].isBotUser === true
      });
    if (players.length === 2) players[1].seatIndex = 3;

    const games = {
      contestId,
      _id: gamePlayId,
      startDate: new Date(),
      status: 'Running',
      round: 1,
      turnEndTimestamp: this.getTurnEndTimestamp(
        Number(TIME_FOR_THROW_DICE) + Number(TIME_FOR_GAME_LOADING)
      ),
      modifiedOn: new Date(),
      currentDiceNumber: 0,
      currentTurnId: getUniqueId(),
      currentPlayerId: players[0]._id.toString(),
      noOfPlayer: teams.length,
      firstMover: players[0]._id.toString(),
      createdOn: new Date()
    };

    return { players, games };
  }

  async sendStartGame(players: any[], game: any) {
    const user = {} as any;
    for (const p of players)
      user[p._id.toString()] = {
        tokens: p.tokens,
        seatIndex: p.seatIndex,
        playerId: p._id.toString(),
        userId: p.userId.toString(),
        sessionId: p.sessionId,
        avatarId: p.avatarId,
        username: p.username,
        winning: p.winning,
        isBotUser: p.isBotUser,
        winningType: p.winningType,
        continueSixCounter: p.continueSixCounter,
        rank: p.status === 2 ? p.rank : 0,
        status: p.status,
        missingTurnCounter: p.missingTurnCounter
      };
    const payload = {
      players: Object.values(user).map((value: any) => ({
        playerId: value.playerId,
        seatIndex: value.seatIndex,
        username: value.username,
        sessionId: value.sessionId,
        userId: value.userId,
        avatarId: value.avatarId,
        tokens: value.tokens
      })),
      roomId: game._id.toString(),
      startPlayerId: players[0]._id.toString(),
      eventType: 'FROM_FE_TO_GAME',
      eventName: 'startGame'
    };

    sendEventToGame(payload);

    await this.setCronEvent(
      {
        gameId: game._id.toString(),
        playerId: players[0]._id.toString(),
        userId: players[0].userId.toString(),
        currentTurnId: game.currentTurnId.toString(),
        isThrowByTimer: false,
        randomTime: Number(TIME_FOR_THROW_DICE) + Number(TIME_FOR_GAME_LOADING)
      },
      players[0].isBotUser
    );
  }

  getNextPlayerIndexAndId(players: { [key: string]: any }, currentPlayerId: string) {
    const playersArray = Object.values(players).sort(
      (player1: any, player2: any) => player1.seatIndex - player2.seatIndex
    );
    const runningPlayer = playersArray.filter((value) => value.status === 1);
    const currentPlayerIndex = runningPlayer.findIndex(
      (player) => player.seatIndex === players[currentPlayerId].seatIndex
    );
    const nextPlayerIndex = getNextPlayer(currentPlayerIndex, runningPlayer.length);
    const nextPlayer = runningPlayer[nextPlayerIndex];
    return {
      nextPlayerId: nextPlayer.playerId,
      nextPlayerSeatIndex: nextPlayer.seatIndex,
      nextPlayerUserId: nextPlayer.userId
    };
  }

  getPlayerUpdateRequest(playerId: string, data: any, hasWonPlayer = false): Partial<any> {
    const playerUpdate = {
      continueSixCounter: data.players[playerId].continueSixCounter,
      tokens: data.players[playerId].tokens,
      modifiedOn: new Date(),
      missingTurnCounter: data.players[playerId].missingTurnCounter
    } as Partial<any>;
    if (hasWonPlayer) {
      playerUpdate['rank'] = data.players[playerId].rank;
      playerUpdate['winning'] = data.players[playerId].winning;
      playerUpdate['winningType'] = data.players[playerId].winningType;
      playerUpdate['gamePlayFinishedTime'] = new Date();
      playerUpdate['score'] = 4 - data.players[playerId].rank;
      playerUpdate['status'] = 2;
      playerUpdate['verified'] = true;
      playerUpdate['payment'] = 'processing';
      data.players[playerId].status = 2;
    } else if (data.players[playerId].missingTurnCounter >= 3) {
      playerUpdate['rank'] = data.players[playerId].rank;
      playerUpdate['gamePlayFinishedTime'] = new Date();
      playerUpdate['score'] = 0;
      playerUpdate['status'] = 2;
      playerUpdate['verified'] = true;
      data.players[playerId].status = 2;
    }
    return playerUpdate;
  }

  checkIfNeedToCompletedGame(data: PlayerCacheInfo, ranks: string[]) {
    const noOfWinner = ranks.length;
    const winnerLength = data.winners.length;
    if (ranks.length > 0 && noOfWinner === winnerLength) return true;

    const players = data.players;
    const playersArray = Object.values(players).filter((value) => value.status === 1);
    if (playersArray.length < 2) return true;

    return false;
  }

  async onCompletedGame() {}

  validateToken(tokenIndex?: number) {
    return (
      !isNil(tokenIndex) && !isNaN(tokenIndex) && Number(tokenIndex) >= 0 && Number(tokenIndex) <= 3
    );
  }

  getOpponentToBeKilled(seatIndex: number, position: number, players: { [key: string]: any }): any {
    const safeHouseIndex = this.getSafeHousePosition();
    if (safeHouseIndex.indexOf(position) >= 0) return null;

    return this.getAllOverLappingIndex(seatIndex, position, players);
  }

  checkWinCondition(tokenPositions: number[]): boolean {
    let flag = true;
    for (const position of tokenPositions)
      if (position !== 57) {
        flag = false;
        break;
      }

    return flag;
  }

  getActionTypeForAllToken(tokenPositions: number[], steps: number) {
    const object = {
      nextPlayerCall: true,
      tokens: {}
    } as {
      nextPlayerCall: boolean;
      tokens: { [key: string]: any };
    };

    for (let index = 0; index < tokenPositions.length; index++) {
      const action = this.getTokenAction(tokenPositions[index], steps, index);
      object.tokens[String(index)] = action;
      if (object.nextPlayerCall)
        object.nextPlayerCall = ['CAN_OUT', 'CAN_MOVE'].indexOf(action.action) < 0;
    }

    return object;
  }

  getTokenAction(position: number, steps: number, tokenId: number): any {
    if (position === 0 && steps === 6) return { action: 'CAN_OUT', newIndex: 1, tokenId };

    if (position === 0 && steps !== 6) return { action: 'NO_OUT', newIndex: position, tokenId };

    if (position !== 0 && position + steps > 57)
      return { action: 'NO_MOVE', newIndex: position, tokenId };

    return { action: 'CAN_MOVE', newIndex: position + steps, tokenId };
  }

  getAllOverLappingIndex(
    seatIndex: number,
    position: number,
    players: { [key: string]: any }
  ): any {
    const data = this.getAllPosition(position, seatIndex);
    const overLappingPlayer = {
      isOverLapping: false,
      playerId: '',
      seatIndex: 0,
      tokenIndex: 0
    };
    let isSafeHousePosition = false;
    let samePositionToken = 0;
    for (const player in players)
      if (Object.prototype.hasOwnProperty.call(players, player)) {
        const playerData = players[player];
        if (playerData.status === 1) {
          const playerPosition = data[playerData.seatIndex];
          if (playerData.seatIndex !== seatIndex) {
            const indexes = this.getAllSamePosition(playerData.tokens, playerPosition);
            if (indexes.length === 1) {
              const index = indexes[0];
              if (index >= 0 && [0, 52].indexOf(playerPosition) < 0) {
                overLappingPlayer.playerId = player;
                overLappingPlayer.isOverLapping = true;
                overLappingPlayer.tokenIndex = index;
                overLappingPlayer.seatIndex = playerData.seatIndex;
                samePositionToken = samePositionToken + 1;
              }
            } else if (indexes.length > 1) {
              isSafeHousePosition = indexes.length > 1;
              break;
            }
          }
        }
      }

    if (isSafeHousePosition || samePositionToken > 1) return null;

    return overLappingPlayer.isOverLapping
      ? { ...omit(overLappingPlayer, ['isOverLapping']), tokenPosition: 0 }
      : null;
  }

  getAllSamePosition(token: number[], position: number) {
    const indexes = [] as number[];
    for (let index = 0; index < token.length; index++)
      if (token[index] !== 0 && token[index] === position) indexes.push(index);

    return indexes;
  }

  getAllPosition(position: number, seatIndex: number) {
    const positions = getStartingPosition();
    const result = {} as { [key: string]: number };
    for (const p in positions)
      if (Object.prototype.hasOwnProperty.call(positions, p))
        result[p] = result[p] = this.getSamePosition(seatIndex, Number(p), position);

    return result;
  }

  getSamePosition(defaultSeatIndex: number, newSeatIndex: number, position: number) {
    const result = position + (defaultSeatIndex - newSeatIndex) * 13;
    return result < 0 ? 52 + result : result >= 52 ? result - 52 : result;
  }

  getSafeHousePosition(): number[] {
    const positions = getStartingPosition();
    const safeHouse = [];
    for (const p in positions)
      if (Object.prototype.hasOwnProperty.call(positions, p))
        safeHouse.push(positions[p], positions[p] + 8);

    return [...safeHouse, 52, 53, 54, 55, 56, 57];
  }

  async sendThrowDiceEvent(data: any) {
    const payload = {
      eventType: 'FROM_FE_TO_GAME',
      eventName: 'diceThrown',
      data
    };
    sendEventToGame(payload);
  }

  async sendEventOnGameEnd() {
    const payload = {
      eventType: 'FROM_FE_TO_GAME',
      eventName: 'gameEnd',
      data: {
        ...gameInfo,
        players: Object.values(gameInfo.players).map((value: any) => ({
          playerId: value.playerId,
          seatIndex: value.seatIndex,
          username: value.username,
          userId: value.userId,
          status: value.status,
          avatarId: value.avatarId,
          tokens: value.tokens,
          winning: value.winning,
          winningType: value.winningType,
          rank: value.rank,
          missingTurnCounter: value.missingTurnCounter
        }))
      }
    };
    sendEventToGame(payload);
  }

  async onTurnComplete(gameId: string, data: any) {
    const payload = {
      roomId: gameId,
      eventType: 'FROM_FE_TO_GAME',
      eventName: 'turnCompleted',
      data
    };
    sendEventToGame(payload);
  }

  async checkWinningForPlayingUser() {
    const playersArray: any = Object.values(gameInfo.players).filter(
      (value: any) => value.status === 1
    );
    if (playersArray.length === 1) {
      gameInfo.winners.push(playersArray[0].playerId);
      gameInfo.players[playersArray[0].playerId] = {
        ...gameInfo.players[playersArray[0].playerId],
        winning: 10,
        rank: gameInfo.winners.length,
        status: 2
      };

      gameCompleted = true;
    }
  }

  async logAndNotifyMatchMakingError(data: any) {
    const payload = {
      eventType: 'FROM_FE_TO_GAME',
      roomId: data.gamePlayId.toString(),
      eventName: 'errorOccurred',
      data: { message: 'some internal error occur' }
    };
    sendEventToGame(payload);
  }

  async setCronEvent(request: any, isBotUser = false) {
    clearTimeout(diceTurnTimeout);
    if (gameCompleted) return;
    if (isBotUser) {
      diceTurnTimeout = setTimeout(() => {
        this.runDiceForBot(request, isBotUser);
      }, getRandomInt(MIN_TIME_FOR_BOT_DICE, MAX_TIME_FOR_BOT_DICE));
    } else {
      diceTurnTimeout = setTimeout(() => {
        this.runDiceForBot(request, isBotUser);
      }, MAX_TIME_FOR_BOT_DICE);
    }
  }

  async runDiceForBot(request: any, isBotUser = false) {
    try {
      const { randomTime = 8 } = request;
      const result: any = await this.onThrowDiceByUser({
        playerId: request.playerId,
        userId: request.userId,
        gameId: request.gameId,
        currentTurnId: request.currentTurnId,
        isThrowByTimer: false
      });
      if (result.nextPlayerCall) return;

      const tokens: any = Object.values(result.tokens).filter(
        (value: any) => ['CAN_OUT', 'CAN_MOVE'].indexOf(value.action) >= 0
      );
      const tokenIndex = getRandomInt(0, tokens.length);
      const time = getRandomInt(1, TIME_FOR_THROW_DICE - randomTime - 2);
      await asyncSetTimeOut(1000 * time);
      await this.runTokenByUser({
        ...request,
        tokenIndex: tokens[tokenIndex].tokenId,
        isThrowByTimer: !isBotUser
      });
    } catch (error) {}
  }

  async onThrowDiceByUser(request: any) {
    return this.diceThrownEvent(request);
  }

  async diceThrownEvent(request: any) {
    const { playerId, isThrowByTimer = false } = request;
    try {
      const oldTurnId = clone(gameInfo).currentTurnId;
      const players = gameInfo.players;
      const maxDiceNumber = isThrowByTimer ? 6 : players[playerId].continueSixCounter < 2 ? 7 : 6;
      let diceNumber = getDiceNumber(maxDiceNumber);
      if (maxDiceNumber === 7) diceNumber = 6;
      if (diceNumber === 6)
        players[playerId].continueSixCounter = players[playerId].continueSixCounter + 1;
      else players[playerId].continueSixCounter = 0;

      gameInfo.currentDiceNumber = diceNumber;
      const action = this.getActionTypeForAllToken(players[playerId].tokens, diceNumber);
      const result = {
        ...action,
        currentDiceNumber: diceNumber,
        nextPlayerId: playerId,
        nextPlayerSeatIndex: gameInfo.players[playerId].seatIndex,
        currentPlayerId: playerId,
        hasMissedTurnByPlayer: false,
        currentPlayerSeatIndex: gameInfo.players[playerId].seatIndex,
        currentTurnId: gameInfo.currentTurnId
      } as any;
      gameInfo.currentPlayerUserId = request.userId;
      gameInfo.currentPlayerId = playerId;
      gameInfo.currentPlayerSeatIndex = gameInfo.players[playerId].seatIndex;

      if (action.nextPlayerCall) {
        const { nextPlayerId, nextPlayerSeatIndex, nextPlayerUserId } =
          this.getNextPlayerIndexAndId(players, playerId);
        result['nextPlayerId'] = nextPlayerId;
        result['nextPlayerSeatIndex'] = nextPlayerSeatIndex;
        gameInfo.currentPlayerId = nextPlayerId;
        gameInfo.currentPlayerUserId = nextPlayerUserId;
        gameInfo.currentPlayerSeatIndex = nextPlayerSeatIndex;
        if (nextPlayerId === gameInfo.firstMover.toString()) {
          gameInfo.round = gameInfo.round + 1;
        }
        gameInfo.currentDiceNumber = 0;
        if (isThrowByTimer)
          gameInfo.players[playerId].missingTurnCounter =
            gameInfo.players[playerId].missingTurnCounter + 1;

        if (gameInfo.players[playerId].missingTurnCounter >= 3) {
          result.kickOut = true;
          gameInfo.players[playerId].status = 2;
        }
      }
      if (isThrowByTimer) result.hasMissedTurnByPlayer = true;

      result.missingTurnCounter = gameInfo.players[playerId].missingTurnCounter;
      this.getRankingObjectInResult(gameInfo, result);
      if (action.nextPlayerCall) {
        result.currentTurnId = oldTurnId;
        gameInfo.currentTurnId = getUniqueId();
        gameInfo.turnEndTimestamp = this.getTurnEndTimestamp(Number(TIME_FOR_THROW_DICE));

        const { nextPlayerId, nextPlayerSeatIndex, nextPlayerUserId } =
          this.getNextPlayerIndexAndId(players, playerId);
        result['nextPlayerId'] = nextPlayerId;
        result['nextPlayerSeatIndex'] = nextPlayerSeatIndex;
        gameInfo.currentPlayerId = nextPlayerId;
        gameInfo.currentPlayerUserId = nextPlayerUserId;
        gameInfo.currentPlayerSeatIndex = nextPlayerSeatIndex;

        const nextPlayer = gameInfo.players[gameInfo.currentPlayerId];

        this.setCronEvent(
          {
            playerId: gameInfo.currentPlayerId,
            userId: gameInfo.currentPlayerUserId,
            currentTurnId: gameInfo.currentTurnId,
            isThrowByTimer: false
          },
          nextPlayer.isBotUser
        );
      }

      result.nextTurnId = gameInfo.currentTurnId;
      this.sendThrowDiceEvent(result);
      return result;
    } catch (error) {
      console.log('error', error);
    }
  }

  getRankingObjectInResult(gameInfo: any, result: any) {
    if (result.kickOut) {
      const runningPlayer = Object.values(gameInfo.players).filter(
        (value: any) => value.status === 1
      );
      result['rank'] = runningPlayer.length + 1;
      gameInfo.players[result.currentPlayerId].rank = runningPlayer.length + 1;
      result['winning'] = 0;
      result['winningType'] = 1;
    } else {
      result['rank'] = gameInfo.players[result.currentPlayerId].rank;
      result['winning'] = gameInfo.players[result.currentPlayerId].winning;
      result['winningType'] = gameInfo.players[result.currentPlayerId].winningType ?? 1;
    }
    return result;
  }

  async runDiceByTimer(request: any) {
    const { userId, gameId, playerId, currentTurnId, gameInfo } = request;
    try {
      const currentTurn = gameInfo.currentTurnId === currentTurnId;
      const isValidUserTurn = gameInfo.currentPlayerId === playerId;
      if (!isValidUserTurn || !currentTurn) return;

      let actions: any = { nextPlayerCall: false, tokens: {} } as {
        nextPlayerCall: boolean;
        tokens: { [key: string]: any };
      };
      if (gameInfo.currentDiceNumber !== 0)
        actions = this.getActionTypeForAllToken(
          gameInfo.players[playerId].tokens,
          gameInfo.currentDiceNumber
        );
      else if (gameInfo.currentDiceNumber === 0) {
        const result: any = await this.diceThrownEvent({
          gameId,
          playerId,
          userId,
          currentTurnId,
          isThrowByTimer: gameInfo.currentDiceNumber === 0
        });
        if (result.nextPlayerCall) return;

        actions = result;
      }

      const tokens: any = Object.values(actions.tokens).filter(
        (value: any) => ['CAN_OUT', 'CAN_MOVE'].indexOf(value.action) >= 0
      );
      const tokenIndex = getRandomInt(0, tokens.length);
      await this.runToken({
        gameId,
        playerId,
        userId,
        tokenIndex: tokens[tokenIndex].tokenId,
        isThrowByTimer: gameInfo.currentDiceNumber !== 0
      });
    } catch (error) {}
  }

  async runTokenByUser(request: any) {
    return this.runToken(request);
  }

  async runToken(request: any) {
    const { gameId, playerId, tokenIndex, isThrowByTimer = false } = request;
    try {
      const currentPosition = gameInfo.players[playerId].tokens[tokenIndex];
      const action = this.getTokenAction(currentPosition, gameInfo.currentDiceNumber, tokenIndex);
      if (['NO_OUT', 'NO_MOVE'].indexOf(action.action) >= 0)
        return {
          currentPlayer: gameInfo.players[playerId].tokens,
          nextPlayerId: gameInfo.currentPlayerId,
          nextPlayerSeatIndex: gameInfo.currentPlayerSeatIndex
        };

      gameInfo.players[playerId].tokens[tokenIndex] = action.newIndex;

      let object = {
        gameInfo,
        result: this.getResult(playerId, tokenIndex, gameInfo),
        gameId,
        playerId,
        tokenIndex,
        newPosition: action.newIndex,
        roundChange: false
      } as any;

      if (isThrowByTimer) {
        gameInfo.players[playerId].missingTurnCounter =
          gameInfo.players[playerId].missingTurnCounter + 1;
        object.result.hasMissedTurnByPlayer = true;
      }

      if (!object.result.hasWonPlayer && gameInfo.players[playerId].missingTurnCounter >= 3) {
        object.result.kickOut = true;
        gameInfo.players[playerId].status = 2;
      }

      if (object.result.kickOut) {
        const tokens = clone(gameInfo.players[playerId].tokens);
        tokens[tokenIndex] = currentPosition;
        object.result.kickOutOverLapping = this.tokenOverLapping(
          [],
          playerId,
          tokens,
          gameInfo.players[playerId].seatIndex,
          gameInfo.players,
          true
        );
      }

      object.result.missingTurnCounter = gameInfo.players[playerId].missingTurnCounter;
      object.result.overLappingOldPosition = this.getOverLappingIndexForAllPlayer({
        position: currentPosition,
        seatIndex: gameInfo.players[playerId].seatIndex,
        selectedToken: tokenIndex,
        players: gameInfo.players,
        playerId
      });

      await this.updateKilledUser(object);
      object.result.overLappingPlayer = this.getOverLappingIndexForAllPlayer({
        position: action.newIndex,
        seatIndex: gameInfo.players[playerId].seatIndex,
        selectedToken: tokenIndex,
        players: gameInfo.players,
        playerId
      });
      if (object.result.overLappingPlayer.length > 0)
        object.result.overLappingPlayer.push({
          tokenId: tokenIndex,
          seatIndex: gameInfo.players[playerId].seatIndex,
          tokenPosition: action.newIndex
        });

      await this.updateWinningData(object);
      this.updateUserTurn(object);
      gameInfo.currentDiceNumber = 0;
      gameInfo.currentTurnId = getUniqueId();
      object.result.nextTurnId = getUniqueId();
      gameInfo.turnEndTimestamp = this.getTurnEndTimestamp(Number(TIME_FOR_THROW_DICE));

      const nextPlayer = gameInfo.players[gameInfo.currentPlayerId];
      this.onTurnComplete(gameId, object.result);
      await this.checkWinningForPlayingUser();
      if (!gameCompleted)
        this.setCronEvent(
          {
            gameId,
            playerId: gameInfo.currentPlayerId,
            userId: gameInfo.currentPlayerUserId,
            currentTurnId: gameInfo.currentTurnId,
            isThrowByTimer: false
          },
          nextPlayer.isBotUser
        );
      else this.sendEventOnGameEnd();

      return object.result;
    } catch (error) {}
  }

  getResult(playerId: string, tokenIndex: number, gameInfo: PlayerCacheInfo) {
    return {
      currentPlayerSelectTokenIndex: tokenIndex,
      selectedTokenNewPosition: gameInfo.players[playerId].tokens[tokenIndex],
      nextPlayerId: gameInfo.currentPlayerId,
      hasWonPlayer: false,
      kickOut: false,
      winners: gameInfo.winners,
      hasMissedTurnByPlayer: false,
      nextPlayerSeatIndex: gameInfo.currentPlayerSeatIndex,
      killedUser: null,
      currentPlayerId: playerId,
      needToCompletedGame: false,
      overLappingPlayer: {},
      kickOutOverLapping: {},
      currentTurnId: gameInfo.currentTurnId,
      currentPlayerSeatIndex: gameInfo.players[playerId].seatIndex
    } as any;
  }

  async updateKilledUser(object: any) {
    const { playerId, newPosition, result } = object;
    result['killedUser'] = this.getOpponentToBeKilled(
      gameInfo.players[playerId].seatIndex,
      newPosition,
      gameInfo.players
    );
    const killedUser = result.killedUser;
    if (!isNil(killedUser)) {
      gameInfo.players[killedUser.playerId].tokens[killedUser.tokenIndex] = 0;
    }
    object['gameInfo'] = gameInfo;
    object['result'] = result;
    return object;
  }

  updateUserTurn(object: any) {
    const { playerId, newPosition, result } = object;

    // below condition show that if user has one token win or user kill or dice was 6 so same user can play
    // hasWonPlayer show that overall game completed for this user so no need to again same user turn
    const samePlayerTurn =
      !result.hasWonPlayer &&
      !object.result.kickOut &&
      (!isNil(object.result.killedUser) ||
        object.gameInfo.currentDiceNumber === 6 ||
        newPosition === 57);
    if (!samePlayerTurn) {
      const { nextPlayerId, nextPlayerSeatIndex, nextPlayerUserId } = this.getNextPlayerIndexAndId(
        gameInfo.players,
        playerId
      );
      gameInfo.currentPlayerId = nextPlayerId;
      result.nextPlayerId = nextPlayerId;
      gameInfo.currentPlayerSeatIndex = nextPlayerSeatIndex;
      gameInfo.currentPlayerUserId = nextPlayerUserId;
      result.nextPlayerSeatIndex = nextPlayerSeatIndex;
      if (nextPlayerId === gameInfo.firstMover.toString()) {
        object.roundChange = true;
        gameInfo.round = gameInfo.round + 1;
      }
    }
    object['gameInfo'] = gameInfo;
    object['result'] = result;
  }

  async updateWinningData(object: any) {
    const { playerId, result } = object;
    const hasWonPlayer = this.checkWinCondition(gameInfo.players[playerId].tokens);
    if (hasWonPlayer) {
      gameInfo.winners.push(playerId);
      const winning: any = {};
      const userWinning = winning[gameInfo.winners.length];
      gameInfo.players[playerId].rank = gameInfo.winners.length;
      gameInfo.players[playerId].winning = userWinning.winning;
      gameInfo.players[playerId].winningType = userWinning.winningType;
      gameInfo.players[playerId].status = 2;
      result['hasWonPlayer'] = true;
      result['winnerPlayerId'] = playerId;
      result['rank'] = gameInfo.winners.length;
      result['winning'] = userWinning.winning;
      result['winningType'] = userWinning.winningType;
      result.needToCompletedGame = this.checkIfNeedToCompletedGame(gameInfo, Object.keys(winning));
    } else if (object.result.kickOut) {
      const runningPlayer = Object.values(gameInfo.players).filter(
        (value: any) => value.status === 1
      );
      gameInfo.players[playerId].rank = runningPlayer.length + 1;
      result['rank'] = gameInfo.players[playerId].rank;
      result['winning'] = 0;
      gameInfo.players[playerId].status = 2;
      result['winningType'] = 1;
    } else {
      result['rank'] = gameInfo.players[playerId].rank;
      result['winning'] = gameInfo.players[playerId].winning;
      result['winningType'] = gameInfo.players[playerId].winningType ?? 1;
    }

    // await this.checkWinningForPlayingUser();

    object['gameInfo'] = gameInfo;
    object['result'] = result;
  }

  tokenOverLapping(
    uniqKeyArray: string[],
    playerId: string,
    tokens: number[],
    seatIndex: number,
    players: { [key: string]: any },
    kickOut: boolean
  ) {
    const overLappingArray = [] as {
      tokenId: number;
      seatIndex: number;
      tokenPosition: number;
    }[][];
    for (let index = 0; index < tokens.length; index++) {
      const key = `seatIndex:${seatIndex}:token:${index}`;
      if (uniqKeyArray.indexOf(key) < 0) {
        const data = this.getOverLappingIndexForAllPlayer({
          position: tokens[index],
          seatIndex: seatIndex,
          selectedToken: index,
          players: players,
          playerId
        });
        if (data.length > 0) {
          const array = [];
          for (const p of data) {
            if (kickOut) {
              if (p.seatIndex !== seatIndex) array.push(p);
            } else array.push(p);

            uniqKeyArray.push(`seatIndex:${p.seatIndex}:token:${p.tokenId}`);
          }
          uniqKeyArray.push(key);
          if (!kickOut)
            array.push({
              tokenId: index,
              seatIndex,
              tokenPosition: tokens[index]
            });

          overLappingArray.push(array);
        }
      }
    }
    return overLappingArray;
  }

  getOverLappingIndexForAllPlayer(
    request: any
  ): { tokenId: number; tokenPosition: number; seatIndex: number }[] {
    const { position, seatIndex, selectedToken, players, playerId } = request;
    const overLappingPlayer = [] as { tokenId: number; tokenPosition: number; seatIndex: number }[];
    const currentPlayer = players[playerId];
    for (let count = 0; count < currentPlayer.tokens.length; count++)
      if (
        currentPlayer.tokens[count] !== 0 &&
        currentPlayer.tokens[count] === position &&
        count !== selectedToken
      )
        overLappingPlayer.push({
          tokenId: count,
          seatIndex: seatIndex,
          tokenPosition: position
        });
    if (ludoDefaultSafeHousePosition.indexOf(position) >= 0) return overLappingPlayer;

    const data = this.getAllPosition(position, seatIndex);
    for (const player in players)
      if (Object.prototype.hasOwnProperty.call(players, player)) {
        const playerData = players[player];
        if (playerData.status === 1) {
          const playerPosition = data[playerData.seatIndex];
          for (let index = 0; index < playerData.tokens.length; index++) {
            const currentUser = seatIndex === playerData.seatIndex;
            if (
              !currentUser &&
              playerData.tokens[index] !== 0 &&
              playerData.tokens[index] === playerPosition &&
              [0, 52].indexOf(playerPosition) < 0
            )
              overLappingPlayer.push({
                tokenId: index,
                seatIndex: playerData.seatIndex,
                tokenPosition: playerPosition
              });
          }
        }
      }

    return overLappingPlayer;
  }

  getTurnEndTimestamp(second: number) {
    const date = new Date();
    date.setSeconds(date.getSeconds() + second);
    return getTimeStamp(date);
  }
}

const gameService = new GameService();
const gamePlayId = getUniqueId();
const contestId = getUniqueId();

export const startLudoGame = (opponentUserDetail: any) => {
  teams[1].username = opponentUserDetail.username;
  teams[1].avatarId = opponentUserDetail.avatarId;
  const { players, games } = gameService.createGameAndTeam(gamePlayId, contestId, teams) as any;
  gameCompleted = false;
  gameService.sendStartGame(players, games);
};

const onMessage = (e: any) => {
  const { eventName, eventType = '' } = e.data;
  if (eventType === 'FROM_GAME_TO_FE') {
    switch (eventName) {
      case 'throwDice':
        clearTimeout(diceTurnTimeout);
        gameService.diceThrownEvent(e.data.data);
        break;
      case 'selectToken': {
        const { playerId = '' } = e.data.data;
        if (!playerId) return;
        gameService.runToken(e.data.data);
        break;
      }
    }
  }
};

window.addEventListener('message', onMessage);
